import React, { Component } from 'react';
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types';
import { TextField } from '@material-ui/core';
import FilePicker from '../FilePicker';
import RadioButtonSelector from '../RadioButtonSelector';
import styles from './styles.scss';
import { get, isBoolean } from 'lodash';
import cx from 'classnames';
import { industryShape, radioOptionsPropsType } from '../../helpers/propTypes';
import IndustryCategorization from './IndustryCategorization';
import InvitationForm from '../InvitationForm';
import {
  ADOBE_ANALYTICS_FEATURE_FLAG_KEY,
  ADVERTISER_CONNECTION_LABEL,
  ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY,
  AVAILABLE_CONNECTION_TYPES,
  GOOGLE_BIGQUERY_FEATURE_FLAG_KEY,
  TRACKING_SOURCE_NAME,
  ATTRIBUTE_CONNECTION_AGENT
} from '../../helpers/constant';
import { connect } from "react-redux";
import { getAdvertiser } from '../../state/modules/app/advertiser';
import { checkEnableFeatureFlag, getEnabledFlags, getEnabledFlagsInConfigApp, isDormantUaAdvertiser, checkUaOnlyAdvertiser } from '../../helpers/common';

const styledTextFieldProps = {
  InputProps: {
    classes: {
      input: styles.customInput,
      notchedOutline: styles.customBorderInput,
    },
  },
  InputLabelProps: {
    classes: {
      root: styles.customLabelRoot,
    },
  },
  variant: 'outlined',
};

@connect((state, props) => {
  const enabledFlags = getEnabledFlags(props, state);
  const enabledFlagsConfigApp = getEnabledFlagsInConfigApp(props, state);
  const isEnabledPixelConnectionType = checkEnableFeatureFlag(enabledFlags, [ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY]);
  const isEnabledGBQConnectionType = checkEnableFeatureFlag(enabledFlags, [GOOGLE_BIGQUERY_FEATURE_FLAG_KEY]);
  const isEnabledAdobeConnectionType = checkEnableFeatureFlag(enabledFlagsConfigApp, [ADOBE_ANALYTICS_FEATURE_FLAG_KEY]);
  const isAgentActionsFeatureEnabled = checkEnableFeatureFlag(enabledFlagsConfigApp, [ATTRIBUTE_CONNECTION_AGENT]);
  const appSetting = get(state, 'appSetting.data', []);
  const baseUrl = get(state, 'config.urlApi.baseUrl', '');
  const connectionTypesCustomLabel = appSetting.find(item => item.setting_name === ADVERTISER_CONNECTION_LABEL);
  return {
    getAdvertiser: getAdvertiser(state),
    [ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY]: isEnabledPixelConnectionType,
    [GOOGLE_BIGQUERY_FEATURE_FLAG_KEY]: isEnabledGBQConnectionType,
    [ADOBE_ANALYTICS_FEATURE_FLAG_KEY]: isEnabledAdobeConnectionType,
    isAgentActionsFeatureEnabled,
    connectionTypesCustomLabel: get(connectionTypesCustomLabel, 'setting_value', []),
    baseUrl,
  };
})
export default class AdvertiserCommonInfo extends Component {
  static propTypes = {
    onSelectLogo: func.isRequired,
    onMultiMarketChange: func.isRequired,
    onNameChange: func.isRequired,
    advertiser: shape({
      advertiser_name: string,
      advertiser_id: oneOfType([string, number]),
      deleteId: oneOfType([string, number]), //current advertiserId pass from Advertiser/index.js
      errMsg: string,
      logo: shape({
        url: string,
      }),
      isMultiMarket: bool,
      industry: industryShape,
    }),
    displayMultiMarkets: bool,
    logoTitle: string,
    logoDescription: string,
    recommendedImageText: string,
    defaultSaveBtnLabel: string,
    secondarySaveBtnLabel: string,
    cancelButtonLabel: string,
    addingAdvertiserUrl: string,
    textFieldLabel: string,
    invitation: string,
    advertiserURLField: string,
    multiMarketTitle: string,
    className: string,
    multiMarketOptions: radioOptionsPropsType,
    connectionTypeOptions: radioOptionsPropsType,
    editMultiMarketMsg: string,
    connectionTypeLabel: string,
    onIndustryCategorizationChange: func,
    onConnectionTypeChange: func,
    edit: bool,
    connectionTypeDisableLabel: string,
    onEmailInfoChange: func,
    getAdvertiser: func,
    [ATTRIBUTE_PIXEL_FEATURE_FLAG_KEY]: bool,
    [GOOGLE_BIGQUERY_FEATURE_FLAG_KEY]: bool,
    [ADOBE_ANALYTICS_FEATURE_FLAG_KEY]: bool,
    connectionTypeDisabledFlagLabel: string,
    sendInstructionTitle: string,
    uaAdvertiserConnectionTypeDisabledLabel: string,
    connectionTypesCustomLabel: arrayOf(shape({})),
    isAgentActionsFeatureEnabled: bool.isRequired,
    baseUrl: string,
  };

  static defaultProps = {
    addingAdvertiserUrl: 'Recommended to enable the Connection Agent and generate a custom connection guide. Please copy & paste the URL directly from your browser.',
    textFieldLabel: 'Advertiser Name',
    invitation: 'Invitation',
    advertiserURLField: 'Advertiser URL',
    multiMarketTitle: 'Is this advertiser in multiple markets?',
    logoDescription: 'This image will appear in reports.',
    recommendedImageText: 'Recommended: 250x100 .JPG or .PNG',
    logoTitle: 'Advertiser Logo',
    editMultiMarketMsg: 'This change will only apply to new campaigns.',
    multiMarketOptions: [
      {
        name: 'No, Advertiser is located in single-metro area',
        value: '0',
      },
      {
        name: 'Yes, Advertiser is located in multiple-metro areas',
        value: '1',
      },
    ],
    connectionTypeLabel: 'Attribute Connection Type',
    connectionTypeOptions: AVAILABLE_CONNECTION_TYPES,
    connectionTypeDisableLabel:
      'Attribute Connection Type can only be updated for advertisers without current or future campaigns',
    connectionTypeDisabledFlagLabel:
      'Attribute Connection Type Change is not supported for this Advertiser',
    uaAdvertiserConnectionTypeDisabledLabel: `Attribute connection Type can not be updated here for advertisers. Please view your UA advertiser's Connection Details to add a GA4 connection for updated connection type and reporting.`,
    sendInstructionTitle: 'Email Invite to Connect',
  };

  state = {
    isEditing: null,
    isChangeConnectionType: false,
    selectedConnectionType: null,
    advertiserUrl: '',
    isUrlChanged: false,
    isModifiedByAgent: false,
    revertedOnce: false,
  };

  componentDidUpdate(prevProps) {
    const { advertiser: {trackingDataSourceName: prevTrackingDataSourceName} } = prevProps;
    const { advertiser: { trackingDataSourceName }} = this.props;
    const { isChangeConnectionType } = this.state;

    if (isChangeConnectionType && prevTrackingDataSourceName !== trackingDataSourceName && trackingDataSourceName !== TRACKING_SOURCE_NAME.WEB_UPLOAD) {
      this.invitationFormRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'start',
      });
    }
  };
  
  invitationFormRef = React.createRef();

  get oldAdvertiser() {
    const {
      advertiser: { deleteId: advertiserId },
      getAdvertiser,
    } = this.props;
    const oldAdvertiser = getAdvertiser(advertiserId);

    return oldAdvertiser;
  };

  handleNameChange = (e) => {
    const { onNameChange } = this.props;
    onNameChange && onNameChange(e);
  };

  handleUrlChange = (e) => {
    const advertiserUrl = e.target.value;
    this.setState({
      advertiserUrl,
    });
  };

  handleMultiMarketChange = (selectedValue) => {
    const { onMultiMarketChange } = this.props;
    onMultiMarketChange && onMultiMarketChange(selectedValue);
    this.setState({
      isEditing: true,
    });
  };

  handleSelectLogo = (res) => {
    const { onSelectLogo } = this.props;
    onSelectLogo && onSelectLogo(res);
  };

  handleIndustryCategorizationChange = (industry) => {
    const { onIndustryCategorizationChange } = this.props;
    onIndustryCategorizationChange && onIndustryCategorizationChange(industry);
  };

  handleConnectionTypeChange = (selectedValue) => {
    const { onConnectionTypeChange } = this.props;
    onConnectionTypeChange && onConnectionTypeChange(selectedValue);
    const isChangeConnectionType = this.oldAdvertiser.trackingDataSourceName !== selectedValue;
    this.setState({
      isEditing: true,
      isChangeConnectionType,
      selectedValue: selectedValue,
    });
  };

  handleEmailInfoChange = (emailInfo) => {
    const { onEmailInfoChange } = this.props;
    onEmailInfoChange && onEmailInfoChange(emailInfo);
  }

  renderMultiMarketSelector() {
    const {
      advertiser,
      multiMarketOptions,
      multiMarketTitle,
      editMultiMarketMsg,
    } = this.props;

    const { isEditing } = this.state;

    const isMultiMarket = get(advertiser, 'isMultiMarket');
    const [no, yes] = multiMarketOptions;
    const isMultiMarketVal = !isBoolean(isMultiMarket)
      ? isMultiMarket
      : isMultiMarket
      ? yes.value
      : no.value;
    const multiMarketErrMsg = get(advertiser, 'multiMarketErrMsg');
    const advertiserId = get(advertiser, 'advertiserId');
    const isShowMsg =
      isEditing &&
      advertiserId &&
      this.oldAdvertiser.isMultiMarket !== isMultiMarket;

    return (
      <div className={styles.multiMarket}>
        <div className={styles.title}>
          <span data-test="addAdvFormMulMarketTitle">{multiMarketTitle}</span>
        </div>
        <RadioButtonSelector
          classname={styles.multiMarketRadioGroup}
          options={multiMarketOptions}
          selectedValue={isMultiMarketVal}
          onChange={this.handleMultiMarketChange}
          isDefaultSelectDisabled
          formControlClasses={styles.radioButtonGroup}
        />
        {isShowMsg && (
          <div className={styles.message}>{editMultiMarketMsg}</div>
        )}

        {multiMarketErrMsg && (
          <p data-test="multiMarketError" className={styles.error}>
            {multiMarketErrMsg}
          </p>
        )}
      </div>
    );
  }

  renderConnectionTypeSelector() {
    const {
      connectionTypeLabel,
      connectionTypeOptions,
      advertiser,
      edit,
      connectionTypeDisableLabel,
      connectionTypeDisabledFlagLabel,
      uaAdvertiserConnectionTypeDisabledLabel,
      connectionTypesCustomLabel,
    } = this.props;
    const {
      trackingDataSourceName,
      trackingDataSourceNameError,
      campaigns = [],
    } = advertiser;
    const hasFutureCampaign = campaigns.some((campaign) => {
      const endDate = new Date(get(campaign, 'end_date')).getTime();
      const now = new Date().getTime();
      return endDate > now;
    });
    
    let isSourceSelectorDisabled = (edit && hasFutureCampaign) || isDormantUaAdvertiser(advertiser);
    let label = isSourceSelectorDisabled
      ? connectionTypeDisableLabel
      : connectionTypeLabel;

    if (isSourceSelectorDisabled && checkUaOnlyAdvertiser(advertiser)) {
      label = uaAdvertiserConnectionTypeDisabledLabel;
    }

    const renderValue = trackingDataSourceName

    const displayedConnectionTypeOptions = connectionTypeOptions
      .filter((option) => {
        const { featureFlagKey, value } = option || {};
        // For cases the feature flags are disabled but the selected connection type relates to the feature flags
        if (
          renderValue === value &&
          featureFlagKey &&
          !this.props[featureFlagKey]
        ) {
          label = connectionTypeDisabledFlagLabel;
          isSourceSelectorDisabled = true;
        }

        // Only display options that don't relate to feature flag, option is selected or has enabled feature flag
        return (
          !featureFlagKey ||
          renderValue === value ||
          (featureFlagKey && this.props[featureFlagKey])
        );
      })
      .map((option) => {
        const { value, name } = option || {};
        const { connection_label: customLabel = '' } =
          connectionTypesCustomLabel.find(
            (item) => item.connection_name === value
          ) || {};
        return {
          ...option,
          name: customLabel ? `${name}, ${customLabel}` : name,
        };
      });

    return (
      <div className={styles.multiMarket}>
        <div className={styles.title}>
          <span>{label}</span>
        </div>
        <RadioButtonSelector
          classname={styles.multiMarketRadioGroup}
          options={displayedConnectionTypeOptions}
          selectedValue={renderValue}
          onChange={this.handleConnectionTypeChange}
          isDefaultSelectDisabled
          formControlClasses={styles.radioButtonGroup}
          disabled={isSourceSelectorDisabled}
        />
        {trackingDataSourceNameError && (
          <p data-test="multiMarketError" className={styles.error}>
            {trackingDataSourceNameError}
          </p>
        )}
      </div>
    );
  }

  render() {
    const {
      advertiser: {
        advertiser_name = '',
        errMsg,
        logo = {},
        industry,
        industryCategorizationError,
        trackingDataSourceName,
        emailInfo,
        loaded,
      },
      className,
      logoDescription,
      logoTitle,
      recommendedImageText,
      addingAdvertiserUrl,
      textFieldLabel,
      invitation,
      advertiserURLField,
      displayMultiMarkets,
      edit,
      sendInstructionTitle,
      isAgentActionsFeatureEnabled,
    } = this.props;
    const { isChangeConnectionType, isEditing } = this.state;

    const urlImage = get(logo, 'url');
    const isShowInviteForm =
      (!edit || isChangeConnectionType) &&
      trackingDataSourceName &&
      trackingDataSourceName !== TRACKING_SOURCE_NAME.WEB_UPLOAD;

    return (
      <div className={cx(styles.details, className, styles.rowLayout)}>
        <div className={styles.column}>
          <TextField
            {...styledTextFieldProps}
            label={textFieldLabel}
            className={styles.advertiserNameField}
            error={!!errMsg}
            helperText={errMsg}
            value={advertiser_name || ''}
            onChange={this.handleNameChange}
            autoFocus
            fullWidth
            data-test="advNameInput"
          />
          <div className={styles.logoContainer}>
            <div className={styles.advertiserLogoTitle}>{logoTitle}</div>
            <div className={styles.advertiserLogoDescription}>
              {logoDescription}
            </div>
            <div className={styles.recommendedImageText}>
              {recommendedImageText}
            </div>
            <FilePicker
              data-test="addAdvFormLogo"
              sourceImage={urlImage}
              onPick={this.handleSelectLogo}
              className={styles.logoUploaderBox}
            />
          </div>
          {displayMultiMarkets && this.renderMultiMarketSelector()}
          {(!edit || loaded || isEditing) && (
            <IndustryCategorization
              edit={edit}
              industry={industry}
              onChange={this.handleIndustryCategorizationChange}
              error={industryCategorizationError}
            />
          )}
          {this.renderConnectionTypeSelector()}
        </div>
        {(this.state.selectedValue === TRACKING_SOURCE_NAME.GA4 || this.state.selectedValue === TRACKING_SOURCE_NAME.PIXEL) && isAgentActionsFeatureEnabled && isShowInviteForm ? 
          (<div>
            <div className={styles.advertiserNameContainer}>
              <TextField
                {...styledTextFieldProps}
                label={advertiserURLField}
                className={styles.advertiserNameField}
                value={this.state.advertiserUrl || ''}
                onChange={this.handleUrlChange}
                autoFocus
                fullWidth
                data-test="advUrlInput"
                placeholder="add advertiser homepage URL"
              />
            </div>
            <div className={styles.textUrl}>
              {addingAdvertiserUrl}
            </div>
            <div className={styles.textInvitation}>
              {invitation}
            </div>
          </div>) 
        : null }
          
        <div className={styles.emailContainer} ref={this.invitationFormRef}>
          {isShowInviteForm && (
            <InvitationForm
              baseUrl={this.props.baseUrl}
              title={sendInstructionTitle}
              onEmailInfoChange={this.handleEmailInfoChange}
              emailInfo={emailInfo}
              key={trackingDataSourceName}
              selectedConnectionType={this.state.selectedValue}
              advertiserUrl={this.state.advertiserUrl}
              isDisabled= {this.state.advertiserUrl.length === 0}
            />
          )}
        </div>
      </div>
    );
  }
}
